import { useSelector } from '@shared/store';
import { MBSendButton } from '../components/sendButton';

interface OwnProps {
  draftId: string;
  onClick: () => Promise<void>;
  testID?: string;
}

export function MBChatInputSendButton({ draftId, onClick, testID }: OwnProps) {
  const urgent = useSelector(state => !!state.chatInput.urgentFromDraftId[draftId]);
  return <MBSendButton urgent={urgent} onClick={onClick} testID={testID} />;
}
